/**
 * Marqueur d'échec best-effort ASSUMÉ — à réserver aux cas où l'échec est sans
 * conséquence pour l'utilisateur (retour haptique, cleanup d'un flow annulé).
 * Pour une action métier, faire remonter l'erreur dans l'UI à la place.
 * Existe parce que le lint interdit les `.catch(() => {})` anonymes.
 */
export const swallow = (): void => undefined;
